// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"InputLabel_InputLabel__9e3Og","error":"InputLabel_error__9X_RI"};